import { selectAllVariants } from '@ff-scene-plugins/photo-prints-redux/selectors/variantSelectors';
import { PhotoPrintsPdpState } from '@ff-scene-plugins/photo-prints-redux/store';
import { PhotoPrintsJson } from '@ff-scene-plugins/photo-prints-shared/PhotoPrintsJson';
import { findVariant } from '@ff-scene-plugins/photo-prints-shared/variants';
import cuid from 'cuid';

export const toGroupIfVariantExists = (
    state: PhotoPrintsPdpState, paperId: string, sizeId: string, groupId = cuid(), borderId?: string
): PhotoPrintsJson.Group | undefined => {

    const variant = findVariant(selectAllVariants(state), {
        paperId,
        sizeId,
        borderId
    });

    if (variant) {
        return {
            id: groupId,
            variantId: variant.id,
            amountInQueue: 0
        };
    }
};